// @flow
/* eslint-disable eqeqeq */
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

export type EntityImportTableModelType = {
    headers: Array<EntityImportHeaderModelType>,
    rows: Array<EntityImportRowModelType>
};

export type EntityImportHeaderModelType = {
    title: string,
    id: string,
    accessor?: Array<string>,
    getModelFieldAccessor?: ?Function, // will be used for getting field accessor for modal format
    disabled?: boolean,
    fixed?: boolean,
    required?: boolean,
    customFieldsKey?: string,
    processCell?: ?Function,
    serializeCell?: ?Function, // will be used for sanitizing values after edit
    validateCell?: ?Function,
    validateCellAsync?: ?Function,
    getIdForAsyncValidation?: ?Function,
    importable: boolean,
    readOnly?: boolean // will be used to as an alternative to disabled while focusable
};

export type EntityImportRowModelType = {
    [key: string]: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class EntityImportTable extends ImmutableModel {
    static fromJS(json: EntityImportTableModelType): EntityImportTable {
        const state: Object = Object.assign({}, json);
        state.headers = Immutable.List(state.headers).map(item =>
            EntityImportHeader.fromJS(item)
        );
        state.rows = Immutable.List(state.rows).map(item =>
            EntityImportRow.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): EntityImportTableModelType {
        return {
            headers: this.headers.toArray().map(item => item.toJS()),
            rows: this.rows.toArray().map(item => item.toJS())
        };
    }

    get headers(): Immutable.List<EntityImportHeader> {
        return this._state.get('headers');
    }

    setHeaders(headers: Immutable.List<EntityImportHeader>): this {
        return this.clone(this._state.set('headers', headers));
    }

    get rows(): Immutable.List<EntityImportRow> {
        return this._state.get('rows');
    }

    setRows(rows: Immutable.List<EntityImportRow>): this {
        return this.clone(this._state.set('rows', rows));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class EntityImportHeader extends ImmutableModel {
    static fromJS(json: EntityImportHeaderModelType): EntityImportHeader {
        const state: Object = Object.assign({}, json);
        state.accessor = state.accessor
            ? Immutable.List(state.accessor)
            : state.accessor;
        return new this(Immutable.Map(state));
    }

    toJS(): EntityImportHeaderModelType {
        const js: EntityImportHeaderModelType = {
            title: this.title,
            id: this.id,
            importable: this.importable
        };

        if (this.accessor != null) {
            js.accessor = this.accessor
                ? this.accessor.toArray()
                : this.accessor;
        }

        if (this.getModelFieldAccessor != null) {
            js.getModelFieldAccessor = this.getModelFieldAccessor;
        }

        if (this.disabled != null) {
            js.disabled = this.disabled;
        }

        if (this.fixed != null) {
            js.fixed = this.fixed;
        }

        if (this.required != null) {
            js.required = this.required;
        }

        if (this.customFieldsKey != null) {
            js.customFieldsKey = this.customFieldsKey;
        }

        if (this.processCell != null) {
            js.processCell = this.processCell;
        }

        if (this.serializeCell != null) {
            js.serializeCell = this.serializeCell;
        }

        if (this.validateCell != null) {
            js.validateCell = this.validateCell;
        }

        if (this.validateCellAsync != null) {
            js.validateCellAsync = this.validateCellAsync;
        }

        if (this.getIdForAsyncValidation != null) {
            js.getIdForAsyncValidation = this.getIdForAsyncValidation;
        }

        if (this.readOnly != null) {
            js.readOnly = this.readOnly;
        }

        return js;
    }

    get title(): string {
        return this._state.get('title');
    }

    setTitle(title: string): this {
        return this.clone(this._state.set('title', title));
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get accessor(): ?Immutable.List<string> {
        return this._state.get('accessor');
    }

    setAccessor(accessor: ?Immutable.List<string>): this {
        return this.clone(this._state.set('accessor', accessor));
    }

    get getModelFieldAccessor(): ?Function {
        return this._state.get('getModelFieldAccessor');
    }

    setGetModelFieldAccessor(getModelFieldAccessor: ?Function): this {
        return this.clone(
            this._state.set('getModelFieldAccessor', getModelFieldAccessor)
        );
    }

    get disabled(): ?boolean {
        return this._state.get('disabled');
    }

    setDisabled(disabled: ?boolean): this {
        return this.clone(this._state.set('disabled', disabled));
    }

    get fixed(): ?boolean {
        return this._state.get('fixed');
    }

    setFixed(fixed: ?boolean): this {
        return this.clone(this._state.set('fixed', fixed));
    }

    get required(): ?boolean {
        return this._state.get('required');
    }

    setRequired(required: ?boolean): this {
        return this.clone(this._state.set('required', required));
    }

    get customFieldsKey(): ?string {
        return this._state.get('customFieldsKey');
    }

    setCustomFieldsKey(customFieldsKey: ?string): this {
        return this.clone(this._state.set('customFieldsKey', customFieldsKey));
    }

    get processCell(): ?Function {
        return this._state.get('processCell');
    }

    setProcessCell(processCell: ?Function): this {
        return this.clone(this._state.set('processCell', processCell));
    }

    get serializeCell(): ?Function {
        return this._state.get('serializeCell');
    }

    setSerializeCell(serializeCell: ?Function): this {
        return this.clone(this._state.set('serializeCell', serializeCell));
    }

    get validateCell(): ?Function {
        return this._state.get('validateCell');
    }

    setValidateCell(validateCell: ?Function): this {
        return this.clone(this._state.set('validateCell', validateCell));
    }

    get validateCellAsync(): ?Function {
        return this._state.get('validateCellAsync');
    }

    setValidateCellAsync(validateCellAsync: ?Function): this {
        return this.clone(
            this._state.set('validateCellAsync', validateCellAsync)
        );
    }

    get getIdForAsyncValidation(): ?Function {
        return this._state.get('getIdForAsyncValidation');
    }

    setGetIdForAsyncValidation(getIdForAsyncValidation: ?Function): this {
        return this.clone(
            this._state.set('getIdForAsyncValidation', getIdForAsyncValidation)
        );
    }

    get importable(): boolean {
        return this._state.get('importable');
    }

    setImportable(importable: boolean): this {
        return this.clone(this._state.set('importable', importable));
    }

    get readOnly(): ?boolean {
        return this._state.get('readOnly');
    }

    setReadOnly(readOnly: ?boolean): this {
        return this.clone(this._state.set('readOnly', readOnly));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class EntityImportRow extends ImmutableModel {
    static fromJS(json: EntityImportRowModelType): EntityImportRow {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): EntityImportRowModelType {
        return {};
    }
}
